import { COBROWSER_PERMISSION } from "./model";
export class Users {
    constructor() {
        this.ids = {};
        this.endpoints = {};
    }
    hasId(id) {
        return id in this.ids;
    }
    hasEndpoint(endpoint) {
        return endpoint in this.endpoints;
    }
    getId(endpoint) {
        return this.endpoints[endpoint];
    }
    getUser(id) {
        return this.ids[id];
    }
    getUsers() {
        return Object.values(this.ids);
    }
    addUser(user, permissions, metadata) {
        var _a, _b, _c;
        var _d, _e, _f, _g;
        (_a = (_d = this.ids)[_e = user.id]) !== null && _a !== void 0 ? _a : (_d[_e] = { id: user.id, endpoints: {}, permissions });
        this.ids[user.id].endpoints[user.endpoint] = true;
        (_b = (_f = this.ids[user.id]).permissions) !== null && _b !== void 0 ? _b : (_f.permissions = permissions || {
            view: false,
            control: false,
        });
        (_c = (_g = this.ids[user.id]).metadata) !== null && _c !== void 0 ? _c : (_g.metadata = metadata);
        this.endpoints[user.endpoint] = user.id;
    }
    setPermission(id, permission) {
        if (this.hasId(id)) {
            this.ids[id].permissions[permission] = true;
        }
    }
    unsetPermission(id, permission) {
        if (this.hasId(id)) {
            this.ids[id].permissions[permission] = false;
        }
    }
    hasPermission(id, permission) {
        return this.hasId(id) && this.ids[id].permissions[permission];
    }
    removeUser(id) {
        delete this.ids[id];
    }
    get length() {
        return Object.keys(this.ids).length;
    }
    toString() {
        return JSON.stringify(this.ids);
    }
}
